export const GiftCardLimits = {
  maxGiftCardNumberLength: 16,
  maxPinNumberLength: 8,
};
